export enum TicketRecallStatus {
  CONTACTING = "CONTACTING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  TIMED_OUT = "TIMED_OUT",
  CANCELLED = "CANCELLED"
}
